//@ts-nocheck
import React, { useState, useRef } from 'react'
import { Transforms, Editor, Node } from 'slate'
import { ReactEditor } from 'slate-react'
import { ModalBody, ModalHeader, ModalFooter, Button, ButtonGroup, Field, TextInput } from '../../../../../../../../index';
import { ImageEditForm } from '../../../image/ImageEditForm'
//@ts-ignore
import styles from './style.module.css'
import './style.css'
import { cloneDeep } from 'lodash';
import { v4 } from 'uuid';
import classNames from 'classnames';
import ImageSizeField from '../../../image/ImageSizeField';
import { getInitialWidthHeight, calculateImageDimensions, isPositiveNumber } from '../../../image';


export const EditCaptionAlt = ({ element, editor, slatePath, entry, ...props }) => {
  const { type } = element.attrs
  const [updatedFormData, setUpdatedFormData] = useState()
  const [hasError, setHasError] = useState(false)
  const [naturalImageWH, setNaturalImageWH] = useState();
  const imagePreviewRef = useRef(null);
  const imageSizeInputEnabled = props.imageSizeInputEnabled;

  const updateFormData = (formData) => {
    if (imageSizeInputEnabled) {
      imagePreviewRef.current.style.width = formData.width && isPositiveNumber(formData.width) ? `${formData.width}px` : 'auto'
      imagePreviewRef.current.style.height = formData.height && isPositiveNumber(formData.height) ? `${formData.height}px` : 'auto'
    }
    setUpdatedFormData(prev => ({ ...prev, ...formData }))
  }

  const handleFormSubmit = (values) => {
    let fields = { ...values }

    if (fields['inline']) {
      if (fields['position'] === 'center' || !fields['position']) {
        fields['position'] = 'left'
      }
    }
    const path = ReactEditor.findPath(editor, element)
    const newAttributes = {
      ...element.attrs,
      "redactor-attributes": {
        ...element.attrs?.["redactor-attributes"]
      },
      style: {
        ...element.attrs?.style
      }
    }
    Object.entries(fields).forEach(([f, v]) => {
      const field = f
      const value: any = v
      if (value && value !== '') {
        if (field !== 'width') {
          newAttributes["redactor-attributes"][field] = value
        }
        if (field === 'inline') {
          newAttributes['inline'] = value
        }


        if (field === 'url') {
          newAttributes['url'] = value
        }
        if (field === 'caption' || field === 'anchorLink') {
          if (type === 'asset') {
            if (field === 'caption')
              newAttributes['asset-caption'] = value.trim();
            else newAttributes['link'] = value.trim();
          }
          else
            newAttributes[field] = value.trim()
        }

        if (field === 'position') {
          if (type === 'asset') {
            newAttributes['position'] = value;
          }
          if (imageSizeInputEnabled) {
            delete newAttributes.style["width"]
            delete newAttributes.style["max-width"]
            delete newAttributes.style["height"]
            delete newAttributes.style["max-height"]
            delete newAttributes['width']
            delete newAttributes['height']
            delete newAttributes['max-width']
            delete newAttributes['max-height']
            if (value === 'none') {
              newAttributes["redactor-attributes"]['position'] = 'none'
              delete newAttributes.style["text-align"]
              delete newAttributes.style["float"]

              if (fields.width) {
                newAttributes['width'] = fields.width
                newAttributes.style["width"] = `${fields.width}px`
              }
              if (fields.height) {
                newAttributes['height'] = fields.height
                newAttributes.style["height"] = `${fields.height}px`
              }
            } else {
              newAttributes.style["text-align"] = value
              newAttributes["redactor-attributes"]['position'] = value

              if (value !== 'center') {
                if (fields.width) {
                  newAttributes['width'] = fields.width
                  newAttributes['max-width'] = fields.width
                  newAttributes.style["width"] = `${fields.width}px`
                  newAttributes.style["max-width"] = `${fields.width}px`
                }
                if (fields.height) {
                  newAttributes['height'] = fields.height
                  newAttributes['max-height'] = fields.height
                  newAttributes.style["height"] = `${fields.height}px`
                  newAttributes.style["max-height"] = `${fields.height}px`
                }
                newAttributes.style["float"] = value
              }
              else {
                delete newAttributes.style["float"]
                if (fields.width) {
                  newAttributes['width'] = fields.width
                  newAttributes.style["width"] = `${fields.width}px`
                }
                if (fields.height) {
                  newAttributes['height'] = fields.height
                  newAttributes.style["height"] = `${fields.height}px`
                }
              }
            }
          } else {
            if (value === 'none') {
              newAttributes["redactor-attributes"]['position'] = 'none'
              delete newAttributes.style["text-align"]
              delete newAttributes.style["text-align"]
              delete newAttributes.style["float"]
              delete newAttributes.style["width"]
              delete newAttributes.style["max-width"]
              delete newAttributes['max-width']
            } else {
              newAttributes.style["text-align"] = value
              newAttributes["redactor-attributes"]['position'] = value

              if (value !== 'center') {
                if (newAttributes['max-width']) {
                  newAttributes.style["max-width"] = `${newAttributes['max-width']}px`
                  newAttributes['max-width'] = newAttributes['max-width']
                  newAttributes.style["width"] = `${newAttributes.width}px`
                  newAttributes['width'] = newAttributes.width
                }
                else {
                  newAttributes.style["max-width"] = `${newAttributes['width']}px`
                  newAttributes['max-width'] = newAttributes['width']
                }
                newAttributes.style["float"] = value
              }
              else {
                delete newAttributes.style["float"]
                if (newAttributes['max-width']) {
                  newAttributes['width'] = newAttributes['max-width']
                  delete newAttributes.style["width"]
                  delete newAttributes.style["max-width"]
                  delete newAttributes['max-width']
                }
              }
            }
          }
        }
        if (field === 'target') {
          newAttributes.target = value ? '_blank' : '_self';
        }
      } else {
        if (field === 'position') {
          delete newAttributes.style["text-align"]
        }
        if (field === 'alt') {
          delete newAttributes['asset-alt']
        }
        if (field === 'caption') {
          delete newAttributes['asset-caption']
        }
        if (field === 'anchorLink') {
          delete newAttributes[`link`]
        }
        delete newAttributes[field]
        delete newAttributes["redactor-attributes"][field]
      }

      if (field === 'alt') {
        if (type === 'asset') {
          newAttributes['asset-alt'] = value.trim();
          newAttributes["redactor-attributes"]['alt'] = value.trim();
        }
        newAttributes['alt'] = value.trim()
      }
    })
    let node = Node.get(editor, path)
    let newNode = cloneDeep(node)
    newNode.attrs = { ...newAttributes }
    if (newAttributes.inline) {
      if (Editor.isInline(editor, node)) {
        Transforms.setNodes(editor, { attrs: newAttributes }, { at: path })
      }
      else {
        Transforms.removeNodes(editor, { at: path })
        const inlineReference = {
          type: 'p',
          attrs: {},
          uid: v4().split('-').join(''),
          children: [
            { text: '' },
            newNode,
            { text: '' }
          ]
        }
        Transforms.insertNodes(editor, inlineReference, { at: path })
      }
    }
    else {
      if (Editor.isBlock(editor, node)) {
        Transforms.setNodes(editor, { attrs: newAttributes }, { at: path })
      }
      else {
        const parentElemForInlineReference = Editor.parent(editor, path)
        const inlineTextString = Editor.string(editor, parentElemForInlineReference[1])
        if (parentElemForInlineReference?.[0]?.type === 'p' && inlineTextString?.length) {
          Transforms.removeNodes(editor, { at: path })
          path.pop()
          Transforms.insertNodes(editor, newNode, { at: path });
        }
        else {
          path.pop()
          Transforms.removeNodes(editor, { at: path })
          Transforms.insertNodes(editor, newNode, { at: path });
        }
      }
    }

    if (editor.requestProps?.['userAnalytics']) {
      const userAnalytics = editor.requestProps['userAnalytics'];
      const metaData = {
        stack_api_key: editor.requestProps['apiKey'],
        json_rte_field_uid: editor.requestProps['field_uid'],
        json_rte_field_type: editor.requestProps['field_type'],
        embedded_asset_type: element['attrs']['display-type'],
        embedded_asset_uid: element['attrs']['asset-uid'],
        mixpanel: true
      }
      userAnalytics.trackEvent(`Edit Embedded Asset Details`, metaData);
    }
    props.closeModal()
  }

  const handleClose = () => {
    if (editor.requestProps?.['userAnalytics']) {
      const userAnalytics = editor.requestProps['userAnalytics'];
      const metaData = {
        stack_api_key: editor.requestProps['apiKey'],
        json_rte_field_uid: editor.requestProps['field_uid'],
        json_rte_field_type: editor.requestProps['field_type'],
        embedded_asset_type: element['attrs']['display-type'],
        embedded_asset_uid: element['attrs']['asset-uid'],
        mixpanel: true
      }
      userAnalytics.trackEvent(`Cancel ‘Edit Embedded Asset Details’`, metaData);
    }
    props.closeModal();
  }
  const handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    if (!naturalWidth || !naturalHeight) return;
    let width = updatedFormData?.width || element?.attrs?.width || element?.attrs?.["redactor-attributes"]?.width;
    if (width && !isPositiveNumber(width)) width = undefined;
    let height = updatedFormData?.height || element?.attrs?.height || element?.attrs?.["redactor-attributes"]?.height;
    if (height && !isPositiveNumber(height)) height = undefined;
    setNaturalImageWH(getInitialWidthHeight(naturalWidth, naturalHeight, width, height))
  }

  const modalContainerClass = classNames({
    [styles['scrte-form-container']]: !imageSizeInputEnabled,
    [styles['scrte-asset-form-container-big']]: imageSizeInputEnabled
  })
  const imagePreviewClass = classNames({
    [styles['scrte-asset-image-preview-big']]: imageSizeInputEnabled,
    [styles['modal']]: !imageSizeInputEnabled
  })

  return (
    <div className='edit-asset-modal-wrapper cs-auto-draft-modal'>
      <ModalHeader title="Edit Image Properties" closeModal={props.closeModal} />

      <ModalBody>
        <div className={modalContainerClass}>
          <div className={imageSizeInputEnabled ? styles['scrte-asset-image-container-big'] : styles['asset-edit-thumbnail']}>
            <img onLoad={handleImageLoad}
              ref={imagePreviewRef}
              className={imagePreviewClass}
              src={type === 'asset' ? (entry?.url || element.attrs?.['asset-link']) : element.attrs.url}
              data-testid={'asset-edit-properties__preview'} />
          </div >
          <div className={imageSizeInputEnabled ? styles['scrte-asset-field-container-big'] : styles['edit-form']}>
            <ImageEditForm
              attributes={{
                ...element?.attrs,
                ...element?.attrs?.["redactor-attributes"]
              }}
              updateFormData={updateFormData}
              hasError={{ value: hasError, callback: setHasError }}
            >
              {imageSizeInputEnabled && <ImageSizeField
                naturalImageWH={naturalImageWH}
                attributes={calculateImageDimensions(updatedFormData, element)}
                hasError={{ value: hasError, callback: setHasError }}
                updateFormData={updateFormData}
              />}
            </ImageEditForm>
          </div>
        </div >
      </ModalBody >

      <ModalFooter>
        <ButtonGroup>
          <Button version="v2" key="cancel" buttonType="tertiary" onClick={handleClose} data-testid="asset-edit-properties__cancel">
            Cancel
          </Button>
          <Button
            version="v2"
            key="add"
            disabled={hasError}
            onClick={() => {
              handleFormSubmit(updatedFormData)
            }}
            data-testid="asset-edit-properties__submit"
          >
            Save
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </div >
  )
}
